import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { Check } from 'lucide-react';
const features = ['Comunicación', 'Conexión emocional', 'Rol activo de él', 'Cartas de conversación', 'Tracker de pareja', 'Guiones de conversaciones difíciles', 'Manejo del entorno', 'Ritmos de procesamiento', 'Cierre simbólico por trimestre'];
const outcomes = ['Nombrar lo que sienten sin que se vuelva discusión', 'Entender qué le pasa al otro aunque no lo diga', "Un rol activo y propio para él, no solo 'tareas de ayuda'", 'Rituales semanales de conexión real', 'Herramientas para los miedos que no se animan a decir', 'Equipo, no piloto automático, para cuando llegue el bebé'];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.05
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 10
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function SystemOverview() {
  return <section className="py-12 md:py-24 px-4 md:px-8 bg-brown text-offwhite" data-id="element-273">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-274">
        <SectionHeading title="EL SISTEMA N°1 EN ARGENTINA" light data-id="element-275" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-2 md:mb-4 -mt-4 md:-mt-8" data-id="element-276">
          <img src="https://cdn.magicpatterns.com/uploads/rGEdDJCZ3gDZsqiboVva44/Cambiar_colores_de_texto_y_bombillo__1_-removebg-preview.png" alt="Idea Hub Digital" loading="lazy" decoding="async" className="w-64 md:w-80 lg:w-96 h-auto mx-auto" data-id="element-277" />
        </motion.div>

        <div className="flex flex-col gap-6 md:gap-12 items-center w-full mt-2 md:mt-4" data-id="element-278">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-center" data-id="element-279">
            <h3 className="font-serif text-xl md:text-3xl font-bold mb-2 md:mb-4 text-terracotta" data-id="element-280">
              De Pareja a Familia
            </h3>
            <p className="font-sans text-base md:text-xl mb-5 md:mb-8 text-offwhite/90 max-w-2xl leading-snug" data-id="element-281">
              Sistema completo · 3 Tomos + 3 Bonos · Semana a semana · Todo
              resuelto, trimestre por trimestre.
            </p>

            <div className="flex justify-center gap-2 md:gap-4 mb-5 md:mb-8" data-id="element-282">
              <motion.div whileHover={{
              y: -2
            }} className="bg-offwhite/10 px-4 md:px-6 py-2 md:py-3 rounded-xl border border-offwhite/5" data-id="element-283">
                <span className="block font-serif text-xl md:text-3xl font-bold text-terracotta leading-none mb-1" data-id="element-284">
                  +30
                </span>
                <span className="text-[10px] md:text-sm font-sans text-offwhite/70 uppercase tracking-wider" data-id="element-285">
                  páginas por tomo
                </span>
              </motion.div>
              <motion.div whileHover={{
              y: -2
            }} className="bg-offwhite/10 px-4 md:px-6 py-2 md:py-3 rounded-xl border border-offwhite/5" data-id="element-286">
                <span className="block font-serif text-xl md:text-3xl font-bold text-terracotta leading-none mb-1" data-id="element-287">
                  6
                </span>
                <span className="text-[10px] md:text-sm font-sans text-offwhite/70 uppercase tracking-wider" data-id="element-288">
                  módulos
                </span>
              </motion.div>
            </div>

            <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
            once: true
          }} className="flex flex-wrap justify-center gap-1.5 md:gap-2 mb-5 md:mb-8 max-w-3xl" data-id="element-289">
              {features.map((f, i) => <motion.span key={i} variants={itemVariants} whileHover={{
              scale: 1.05,
              backgroundColor: 'rgba(250, 246, 240, 0.15)'
            }} whileTap={{
              scale: 0.95
            }} className="px-3 md:px-4 py-1 md:py-1.5 bg-offwhite/5 border border-offwhite/10 rounded-full text-[11px] md:text-sm font-sans text-offwhite/80 cursor-pointer transition-colors" data-id="element-290">
                  {f}
                </motion.span>)}
            </motion.div>

            <p className="font-sans text-xs md:text-base text-terracotta font-medium italic" data-id="element-291">
              Funciona desde la semana 1, en su casa, a su propio ritmo.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-offwhite/5 border border-offwhite/10 p-5 md:p-10 rounded-2xl md:rounded-3xl w-full max-w-2xl text-left shadow-lg" data-id="element-292">
            <h4 className="font-serif text-lg md:text-2xl font-bold mb-4 md:mb-6 text-center text-terracotta" data-id="element-293">
              Lo que van a lograr:
            </h4>
            <motion.ul variants={containerVariants} initial="hidden" whileInView="show" viewport={{
            once: true
          }} className="space-y-2.5 md:space-y-4" data-id="element-294">
              {outcomes.map((outcome, i) => <motion.li key={i} variants={itemVariants} whileHover={{
              x: 4
            }} className="flex gap-2.5 md:gap-3 items-start p-2 rounded-lg hover:bg-offwhite/5 transition-colors cursor-default" data-id="element-295">
                  <Check className="text-terracotta shrink-0 mt-0.5" size={18} data-id="element-296" />
                  <span className="font-sans text-xs md:text-base text-offwhite/90 leading-snug" data-id="element-297">
                    {outcome}
                  </span>
                </motion.li>)}
            </motion.ul>
          </motion.div>
        </div>
      </div>
    </section>;
}